export const LocalStorageKeys = Object.freeze({
  DarkMode: "dark-mode"
});
